module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-14.bf16fb7c.jpg";